import React from 'react'
import PropTypes from 'prop-types'

import BasicViewComponent from './BasicViewComponent'
import Checkbox from '@material-ui/core/Checkbox'
import FormGroup from '@material-ui/core/FormGroup'
import FormControlLabel from '@material-ui/core/FormControlLabel'

class CategoryCheckbox extends BasicViewComponent {

  constructor (props) {
    super(props)
    const category = props.config.categories && props.config.categories.length > 0
      ? props.config.categories[0]
      : props.config.category

    this.state = {
      checked: props.filterSettings.visibility[category]
    }
    this.changeTimer = null
  }

  onChange = () => {
    clearTimeout(this.changeTimer)
    const newChecked = !this.state.checked
    this.setState({
      checked: newChecked
    })
    this.changeTimer = setTimeout(() => {
      if (this.props.config.categories) {
        this.props.config.categories.forEach(category => {
          this.props.setCategoryVisible(category, newChecked)
        })
      }
      else {
        this.props.setCategoryVisible(this.props.config.category, newChecked)
      }
    }, 500)
  }

  render () {
    if (!super.conditionsAreMet()) {
      return null
    }

    const checkbox = (
      <Checkbox
        className={this.cssClass}
        onChange={this.onChange}
        disabled={this.props.config.disabled}
        checked={this.state.checked}
        classes={{
          colorSecondary: 'blue'
        }}
        disableRipple
      />
    )

    const label = (
      <div>
        <img
          alt=''
          src={this.props.config.icon}
          className={`${this.cssClass}_img`}
        />
        <span className={`${this.cssClass}_label`}>
          {this.evalConfigValue(this.props.config.displayName) || this.props.config.category}
        </span>
      </div>
    )

    return (
      <FormGroup component="fieldset">
        <FormControlLabel control={checkbox} label={label}/>
      </FormGroup>
    )
  }

}

CategoryCheckbox.TYPE = 'categoryCheckbox'

CategoryCheckbox.propTypes = {
  config: PropTypes.object.isRequired,
  filterSettings: PropTypes.object,
  setCategoryVisible: PropTypes.func
}

export default CategoryCheckbox



// WEBPACK FOOTER //
// ./src/components/ViewComponents/CategoryCheckbox.js